export default __webpack_public_path__ + "static/media/11_photo.8539ff80.jpg";